export default __webpack_public_path__ + "static/media/banner-tablet-bg-white-template.c5d1b4ef.svg";